import React, { useContext, useEffect, useState } from 'react'
import { Menu, message, Spin } from 'antd'
import { ContextType } from '../../type/type'
import { menuList } from '../../function/menuList'
import { parseUrl } from '../../function/parseUrl'
import { getRequest } from '../../request/request'
import { errors } from '../../function/errors'
import { scrollToAnchor } from '../../function/scrollAnchor/scrollAnchor'
import { NavLink, useNavigate, useParams } from 'react-router-dom'
import { AppContext } from '../../App'
import { t } from 'i18next'

interface DynamicMenuProps {
  defaultType: string
  url: string
  setMenuActive: any
  handleClickMenu: any
  flag?: boolean | undefined
}

const DynamicMenu: React.FC<DynamicMenuProps> = ({ defaultType, url, setMenuActive, flag, handleClickMenu }) => {
  const { type = defaultType } = useParams()
  const { state } = useContext<ContextType>(AppContext)
  const [loading, setLoading] = useState(true)
  const [menu, setMenu] = useState([])
  const [boorList, setBoorList] = useState<any>([])
  const navigate = useNavigate()

  useEffect(() => {
    setLoading(true)
    const idMenu: string | number = parseUrl('?', 'type')

    if (isNaN(+idMenu)) {
      navigate('/')
      message.error('Ошибка URL адреса')
      return
    }

    if (!idMenu) {
      navigate('/')
      message.error('Ошибка URL адреса')
      return
    }

    getRequest(`/pages/page/?category_id=${idMenu}`)
      .then((res) => {
        if (flag) {
          setBoorList([])
          getRequest('/maps/region/').then((res) => {
            res?.data?.results.forEach(({ id, region_name }: { id: number; region_name: string }) => {
              setBoorList((arr: string[]) => [
                ...arr,
                {
                  key: `${id}`,
                  label: <NavLink state={{ breadcrumbs: t('m13') }} to={`/${url}/${id}/maps?type=${idMenu}`}>{region_name}</NavLink>,
                },
              ])
            })
          })
        }
        setLoading(false)
        setMenu(res?.data?.results)
        setMenuActive(true)
      })
      .catch((err) => {
        errors(err)
        setLoading(false)
      })
  }, [state.lang])

  return menu && type ? (
    boorList ? (
      <Menu
        className="w-240"
        selectedKeys={[type]}
        mode="inline"
        defaultOpenKeys={['0']}
        items={menuList(menu, url, boorList)}
        onClick={() => {
          handleClickMenu()
          // scrollToAnchor('content')
        }}
      />
    ) : (
      <Menu
        className="w-240"
        selectedKeys={[type]}
        mode="inline"
        items={menuList(menu, url)}
        // onClick={() => scrollToAnchor('content')}
      />
    )
  ) : (
    <Spin spinning={loading} />
  )
}
export default DynamicMenu
